// Поиск целого псевдослучайного числа от min до max, max не включается
export function getRandomInt(min, max) {
    const val = Math.floor(Math.random() * (max - min + 1) + min);

    return val > max ? max : val;
}

// возвращает рандомное значение из объекта (не включая первый элемент объекта)
export function getRandomProperty(obj) {
    const keys = Object.keys(obj);

    return obj[keys[getRandomInt(1, keys.length - 1)]];
}

// возвращает рандомное значение из массива
export function getRandomElement(set) {
    return set[getRandomInt(0, set.length - 1)];
}
